import React, { ReactElement, useState } from 'react';
import { useFormikContext } from 'formik';
import { useParams } from 'react-router-dom';
import { CentreServiceScolaire, HistoriqueLogs, Lieu, Region } from '../../../../../common/src/entities';
import ChampFormulaire from '../../Common/ChampFormulaire';
import DropdownEntiteFormulaire from '../../Common/DropdownEntiteFormulaire';
import { affichageLieu } from '../Lieux/DetailsLieu';
import FormulaireModificationEntite from '../Utils/FormulaireModificationEntite';
import { schemaCentreServiceScolaire } from '../../../../../common/src/schemas';
import ChampMultipleContact from '../Contacts/ChampMultipleContact';
import ChampsAssocies from '../Utils/ChampsAssociés';
import ChampMultipleCssContact from '../Contacts/ChampMultipleCssContact';
import { ModalDetails } from '../../Common/ModalDetails';
import ChampMultipleLieu from '../Lieux/ChampMultipleLieu';
import LogsLoader, { dateFormatter } from '../Utils/Log';
import { useGetQuery } from '../../../Utils/api';
import { LABEL_COL } from '../constantes';
import { MyPaper } from '../Utils/MyPaper';

const SUGGESTIONS_CONTACT = [
    'Coordonnateur des loisir',
    'Directeur',
    'Directeur adjoint',
    'Directrice',
    'Directrice adjointe',
    'Directrice des loisirs',
    'Enseignant',
    "Enseignant d'éducation physique",
    'Enseignante',
    "Enseignante d'éducation physique",
    'Éducateur',
    'Éducatrice',
    'Éducatrice classe principale',
    'Responsable SDG',
    'Secrétaire',
    'Service de garde',
    'TES',
    'Technicien en loisirs',
    'Technicienne en Loisirs',
];

export function ChampsCentreServiceScolaire(): ReactElement {
    const {
        values: { clients },
    } = useFormikContext<CentreServiceScolaire>();

    const client_combines = [
        ...(clients ?? []).map((c) => ({
            ...c,
            name: <b>{c.name}</b>,
        })),
    ];
    const [afficherModalCssContact, setAfficherModalCssContact] = useState<boolean>(false);
    const [indexModalCssContact, setIndexModalCssContact] = useState<number>(0);

    function ouvrirModalCssContact(index: number): void {
        setAfficherModalCssContact(true);
        setIndexModalCssContact(index);
    }

    return (
        <>
            <MyPaper>
                <ChampFormulaire labelCol={LABEL_COL} id="name" titre="Nom" estPetit />
                <ChampFormulaire labelCol={LABEL_COL} id="abbr" titre="Abréviation" estPetit />
                <DropdownEntiteFormulaire
                    labelCol={LABEL_COL}
                    id="fk_id_region"
                    titre="Région"
                    entite={Region}
                    champs={'region'}
                    estPetit
                />
                <ChampFormulaire labelCol={LABEL_COL} id="link" titre="Lien" estPetit />
                <ChampFormulaire labelCol={LABEL_COL} id="email" titre="Courriel" estPetit />
                <ChampMultipleContact
                    labelCol={LABEL_COL}
                    id="contact_par_defaut"
                    maxSize={1}
                    title="Responsable des services financiers"
                    avecUnBouton
                />
                <ChampMultipleCssContact
                    labelCol={LABEL_COL}
                    id="contacts"
                    details={formikAvoirDetailContact}
                    suggestions={['']}
                    avecUnBouton
                    placeholder="Detail"
                    clickCrayon={ouvrirModalCssContact}
                />
                <ChampMultipleLieu id="lieux" title="Adresse" maxSize={1} labelCol={LABEL_COL} avecUnBouton />
                <ChampFormulaire labelCol={LABEL_COL} id="num_fournisseur" titre="Numéro de fournisseur" estPetit />
                <ChampFormulaire labelCol={LABEL_COL} id="notes" titre="Notes" textarea estPetit />
                <ChampsAssocies labelCol={LABEL_COL} items={client_combines} url="clients" titre="Clients associées" />
            </MyPaper>
            <ModalDetails
                afficher={afficherModalCssContact}
                setAfficher={() => setAfficherModalCssContact(false)}
                detailId={formikAvoirDetailContact(indexModalCssContact)}
                titre={'Détails sur le contact'}
                suggestions={SUGGESTIONS_CONTACT}
            />
        </>
    );
}

export default function DetailsFournisseur(): ReactElement {
    const { id } = useParams() as { id: string };
    const listLogs = useGetQuery<HistoriqueLogs[]>(`historique_logs/${id}/css`);
    return (
        <div>
            <FormulaireModificationEntite
                id={+id}
                entite={CentreServiceScolaire}
                badges={(f: CentreServiceScolaire) => [
                    `Centre de Service Scolaire #${f.id}`,
                    `Dernière modification: ${
                        listLogs.data?.[listLogs.data.length - 1]?.date_modification
                            ? dateFormatter(listLogs.data?.[listLogs.data.length - 1]?.date_modification)
                            : 'Aucune modificiation'
                    }  ${
                        listLogs.data?.[listLogs.data.length - 1]?.nom_usager
                            ? ' par ' + listLogs.data?.[listLogs.data.length - 1]?.nom_usager
                            : ''
                    }`,
                ]}
                schema={schemaCentreServiceScolaire}
                properties_to_reassign={{
                    contact_par_defaut: 'fk_id_contact_par_defaut',
                    lieux: 'fk_id_lieu',
                }}
            >
                <ChampsCentreServiceScolaire />
            </FormulaireModificationEntite>
            <LogsLoader id={id} tableName={'css'} />
        </div>
    );
}
/**
 * Pour pouvoir assigner les postes (qui est une entité client-contact) dans un champ
 * multiple qui est une entité client.
 * @param index position dans le tableau des contacts
 */
function formikAvoirDetailContact(index: number): string {
    return `contacts[${index}].detail`;
}
